/**
 * Pure path/contract helpers for the Go notifications API (ADR-0007).
 * Kept free of React Query / axios so Jest can assert the campus contract
 * without mounting the app: paths are relative to
 * `https://api.campus.varkwave.com/api/v1` (VITE_GO_API_BASE_URL).
 */

export const notificationPaths = {
  list: '/notifications',
  unreadCount: '/notifications/unread-count',
  markRead: (id: string) => `/notifications/${id}/read`,
  markAllRead: '/notifications/read-all',
  /** FCM device registration — NOT the legacy `/api/notifications/tokens/*`. */
  device: '/me/device',
} as const;

export type DevicePlatform = 'android' | 'ios' | 'web';

export interface RegisterDeviceBody {
  fcm_token: string;
  platform: DevicePlatform;
}

/** Builds the PUT /me/device body the Go handler expects. */
export function buildRegisterDeviceBody(
  fcmToken: string,
  platform: DevicePlatform = 'web',
): RegisterDeviceBody {
  return { fcm_token: fcmToken, platform };
}
